// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const getPrezStaticFile = async key => {
  try {
    const prezStaticFile = await axios.post(
      "/api/shared/get-prez-static-file",
      { key }
    );
    return prezStaticFile.data;
  } catch (error) {
    console.error("Utils - Get hub satus - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default getPrezStaticFile;
